import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss'],
    standalone: false
})
export class TitleComponent {
  @Input() title: string;
  @Input() iconName: string;
  @Input() selected = true;
  @Input() showTitle = true;
  @Input() leftAlign = false;
}
